import { 
	SendAlt16,
} from '@carbon/icons';

export default [
	/* **** */
	{
		path: '/profile',
		layout: 'Admin',
		component: 'Profile',
		meta: {
			name: 'Профиль',
		},
	},
	/* **** */
	{
		path: '/profile/notices',
		layout: 'Admin',
		component: 'ProfileNotices',
		meta: {
			name: 'Уведомления',
		},
	},
	/* **** */
	{
		path: '/profile/telegram',
		layout: 'Admin',
		component: 'ProfileTelegram',
		meta: {
			name: 'Привязка Telegram',
			icon: SendAlt16,
		},
		menu: true,
	},
	/* **** */
];
